import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../../../api';
import i18next from 'i18next';
import { Toaster } from 'app/shared/component/toaster';
import { Dispatch } from 'redux';
import { loadingAction } from '../../../../actions/actions';

export const FILE_SUBMIT_EUGBR = 'FILE_SUBMIT_EUGBR';

export const create = createAsyncThunk(
  'eugbr/create',
  async ({ entryFormId, data, callback }: { entryFormId: string; data: any; callback: () => void }) => {
    const response = await api.entryForm.eugbr.create(entryFormId, data);
    callback();
    return response.data;
  }
);

export const deleteEugbr = createAsyncThunk('eugbr/delete', async ({ entryFormId, eugbrId }: { entryFormId: string; eugbrId: string }) => {
  const response = await api.entryForm.eugbr.delete(entryFormId, eugbrId);
  return response.data;
});

export const updateEugbr = async (entryFormId: string, eugbrId: string, data: any, callback: () => void) => {
  const response = await api.entryForm.eugbr.update(entryFormId, eugbrId, data);
  Toaster.success(i18next.t('notifications.success.update'));
  callback();
  return response.data;
};

export async function submitEugbr(id: string, dispatch: Dispatch) {
  try {
    dispatch(loadingAction({ isLoading: true }));

    const response = await api.entryForm.eugbr.submit(id);

    dispatch({ type: FILE_SUBMIT_EUGBR, payload: response.data });

    Toaster.success(i18next.t('notifications.success.update'));
  } catch (error) {
    console.log(error);
    dispatch(loadingAction({ isLoading: false }));
  }
}
